export default {
  API: {
    Base: 'https://apiapplication.businesstrainingshpwc.com'
  },
  PUBLIC_URL: 'https://youplusapplication.businesstrainingshpwc.com',
  PRIVATE_URL: 'http://youplus-crm-test.oss-cn-shanghai.aliyuncs.com'
}
